import { getInstructionPayloadToSave } from './planBuilder';
import { SAVE_POPUP_VARIANT } from './constants';

export const INSTRUCTIONS_ONLY_LINK_SAVE_ACTION = {
    OPEN_LINK_POPUP: 'openLinkPopup',
    CONFIRM_POPUP: 'confirmPopup',
    DEFAULT: 'default',
};

export function resolveInstructionsOnlyLinkSaveAction(saveChangeKind, testCaseId) {
    if (saveChangeKind !== 'instructionsOnly') {
        return INSTRUCTIONS_ONLY_LINK_SAVE_ACTION.DEFAULT;
    }
    if (!testCaseId) {
        return INSTRUCTIONS_ONLY_LINK_SAVE_ACTION.OPEN_LINK_POPUP;
    }
    return INSTRUCTIONS_ONLY_LINK_SAVE_ACTION.CONFIRM_POPUP;
}

export function buildInstructionsOnlyLinkPopupData(studioState) {
    // Always use live draft text — completedInstructions is frozen at generate time.
    const instructionsToSave = studioState?.planDraft?.instructions ?? [];

    return {
        variant: SAVE_POPUP_VARIANT.INSTRUCTIONS_ONLY,
        instruction: getInstructionPayloadToSave(instructionsToSave),
    };
}
